/*
 * @Author: cc
 * @Date: 2020-03-31 16:16:47
 * @LastEditTime: 2020-05-15 13:55:21
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\service\editLeftRouterService.js
 * @Description: 
 */
'use strict';
angular.module('editLeftRouterModule', []).factory('editLeftRouterService', [function() {
    var remRouter = {
        iWo: {
            value: '',
            param: ''
        },
        app: {
            value: '',
            param: ''
        },
        website: {
            value: '',
            param: ''
        },
        newspaper: {
            value: '',
            param: ''
        }
    };
    return {
        setRemRouter: function(tabName, value, param) {
            remRouter[tabName].value = value;
            if (!!param) {remRouter[tabName].param = param;}
        },

        getRemRouter: function(tabName) {
        	return remRouter[tabName];
        }
    };
}]);
